<tag-edit
  [isShowMyDayTag]="true"
  [tagIds]="value"
  [excludedTagIds]="field.templateOptions?.excludedTagIds"
  (tagUpdate)="formControl.setValue($event)"
></tag-edit>

<!--<pre><code>{{value|json}}</code></pre>-->
<!--<pre><code>{{field|json}}</code></pre>-->
